<template>
  <modal :height="500" name="modalEditDevice">
    <div class="modalStyle">
      <h4 class="card-title" v-if="!this.device.edit">Add device</h4>
      <h4 class="card-title" v-if="this.device.edit">Edit device</h4>
      <form @submit="formDeviceEditSubmit" id="formDevice">
        <div class="form-group">
          <div class="col-md-12">
            <base-input id="name"
                        label="Name"
                        name="name"
                        placeholder="Name"
                        type="text"
                        v-model="device.name">
            </base-input>
          </div>
        </div>
        <div class="form-group" v-if="this.isAdmin===true">
          <div class="col-md-12">
            <base-input id="serial"
                        label="Serial"
                        name="serial"
                        placeholder="Serial"
                        type="text"
                        v-model="device.serial">
            </base-input>
          </div>
        </div>
        <div class="form-group" v-if="this.isAdmin===true">
          <label class="col-sm-3 control-label">
            User
          </label>
          <div class="col-md-12">
            <select aria-hidden="true"
                    @change="onUserSelected()"
                    class="form-control vue-select1 select2-hidden-accessible"
                    id="deviceUserSelector"
                    label="User"
                    name="select1"
                    placeholder="User"
                    style="width: 100%"
                    tabindex="-1"
                    v-model="device.userId">
              <option value="0"></option>
              <option :value="userOption.id"
                      :selected="device.userId === userOption.id"
                      v-for="userOption in userOptions">
                {{userOption.email}}
              </option>
            </select>
          </div>
        </div>
        <div class="form-group">
          <label class="col-sm-3 control-label">
            Localization
          </label>
          <div class="col-md-12">
            <select aria-hidden="true"
                    class="form-control vue-select1 select2-hidden-accessible"
                    id="deviceSelector"
                    label="Localization"
                    name="select1"
                    placeholder="Localization"
                    style="width: 100%"
                    tabindex="-1"
                    v-model="device.localizationId">
              <option value="0"></option>
              <option :value="localizationOption.id"
                      :selected="device.localizationId === localizationOption.id"
                      v-for="localizationOption in localizationOptions">
                {{localizationOption.name}}
              </option>
            </select>
          </div>
        </div>
        <div class="buttonModal">
          <button class="btn btn-info btn-fill float-right" v-if="!this.device.edit">
            Add
          </button>
          <button class="btn btn-info btn-fill float-right" v-if="this.device.edit">
            Save
          </button>
        </div>
      </form>
    </div>
  </modal>
</template>
<script>

  import EventBus from "../../event-bus";

  export default {
    name: 'l-modal-device-edit',
    props: {
      isAdmin: false
    },
    data() {
      return {
        device: {
          id: '',
          name: '',
          serial: '',
          description: '',
          user: '',
          localization: '',
          edit: false
        },
        localizationOptions: [],
        userOptions: [],
      }
    },
    methods: {
      onUserSelected() {
        this.loadLocationOptions();
      },
      loadLocationOptions() {
        this.$http.get('localization/list')
          .then(result => {
            this.localizationOptions = [];
            result.data.forEach((obj) => {
              this.localizationOptions.push(obj);
            });
          }, error => {
            console.error(error);
          });
      },
      loadUserOptions() {
        if (this.isAdmin === true) {
          this.$http.get('user/list')
            .then(result => {
              this.userOptions = [];
              result.data.forEach((obj) => {
                this.userOptions.push(obj);
              });
            }, error => {
              console.error(error);
            });
        }
      },
      formDeviceEditSubmit(e) {
        e.preventDefault();

        let url = 'device';
        let method = this.$http.post;

        if (this.device.edit) {
          url += '/' + this.device.id;
          method = this.$http.put;
        }

        method(url, {
          'name': this.device.name,
          'serial': this.device.serial,
          'description': this.device.description,
          'userId': this.device.userId > 0 ? this.device.userId : null,
          'localizationId': this.device.localizationId > 0 ? this.device.localizationId : null,
        }).then(result => {
          console.info("Success");

          EventBus.$emit('EVENT_RELOAD', true);

          this.closeAddModal();
        }, error => {
          console.error(error);
        });
      },
      addDevice() {
        this.device.id = '';
        this.device.name = '';
        this.device.serial = '';
        this.device.description = '';
        this.device.userId = '';
        this.device.localizationId = 0;
        this.device.edit = false;

        this.showAddModal();
      },
      editDevice(item) {
        this.$http.get('device/' + item.id)
          .then(result => {
            this.device = result.data;
            this.device.edit = true;

            this.showAddModal();
          }, error => {
            console.error(error);
          });
      },
      showAddModal() {
        this.loadLocationOptions();
        this.loadUserOptions();

        this.$modal.show('modalEditDevice');
      },
      closeAddModal() {
        this.$modal.hide('modalEditDevice');
      },
    }
  }
</script>
<style>
</style>
